"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiBackdropOverrides = void 0;
var styles_1 = require("@material-ui/core/styles");
var createMuiBackdropOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            backgroundColor: styles_1.fade(palette.common.black, 0.72),
        },
    });
};
exports.createMuiBackdropOverrides = createMuiBackdropOverrides;
//# sourceMappingURL=MuiBackdrop.js.map